module.exports={
    logout  : "Konto stornieren",
    my      :'mein',
    scqx    :'Löschen von Berechtigungen',
    qxgl    :'Verwaltung der Behörde',
    qdzxzhm :'Sind Sie sicher, das Konto zu stornieren?',
    qtxkh   :'Bitte geben Sie die Kartennummer ein',
    qd      :'Bestimmen',
    qx      :'Stornieren',
    gb      :'schließen',
    kh      :'Nummer der Karte',
    kmewm   :'Türöffnung QR-Code',
    dl      :'Melden Sie sich',
    name    :'Name des Benutzers',
    qtxname :'Bitte geben Sie den Benutzernamen ein',
    pwas    :'Passwort',
    qtxpwas :'Bitte geben Sie das Passwort ein',
    tj      :'Senden',
    zczh    :'Registriertes Konto',
    zc      :'Register',
    sjhm    :'Telefon Nummer',
    qtxsjhm :'Bitte geben Sie Ihre Mobiltelefonnummer ein',
    yzm     :'Code der Überprüfung',
    qtxyzm  :'Bitte geben Sie den Verifizierungscode ein',
    yyzhqqdl:'Sie haben bereits ein Konto. Gehen Sie und loggen Sie sich ein',
    hqyzm   :'Verifikationscode erhalten',
    zccg    :'Anmeldung erfolgreich',
    zcsb    :'Anmelden fehlgeschlagen',
    fscg    :'Gesendet erfolgreich',
    fssb    :'scheitern in senden',
    yhycz   :'Der Benutzer existiert bereits',



    xgmm    : "Passwort ändern",
    zhmm    :'Passwort abrufen',
    qrmm    :'Passwort bestätigen',
    zhyxmm  :"Passwort abrufen",
    yxyzm   :'E-Mail-Code zur Überprüfung',
    hqyxyzm :'Zugangscode für die Mailbox',
    zzmmyx  :'Passwort zurücksetzen',
    lcmmbyc :'Die beiden Passwörter sind inkonsistent',
    xgcg    :'Geändert erfolgreich',
    xgsb    :'Änderung fehlgeschlagen',
    qtxyxyx  :'Bitte füllen Sie eine gültige E-Mail-Adresse aus',
    lsmhhq  :'Nach 60 Sekunden abrufen',
    hqyyyzmcg:'Erfolgreich erhaltener Postfach-Verifizierungscode',
    zhmmbd  :'Falsches Passwort'
}